import { render, staticRenderFns } from "./RelatorioTabela.vue?vue&type=template&id=31bca1bd&"
import script from "./RelatorioTabela.vue?vue&type=script&lang=js&"
export * from "./RelatorioTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports